import React from "react";
import PropTypes from "prop-types";
import styles from "./SocialConnection.module.css";

const SocialConnection = ({ className = "" }) => {
  return (
    <div className={[styles.socialConnection, className].join(" ")}>
      <div className={styles.iconWrapper}>
        <img
          className={styles.socialIcon}
          src="/facebook.svg"
          alt="Facebook"
        />
      </div>
      <div className={styles.iconWrapper}>
        <img
          className={styles.socialIcon}
          src="/instagram.svg"
          alt="Instagram"
        />
      </div>
      <div className={styles.iconWrapper}>
        <img
          className={styles.socialIcon}
          src="/twitter.svg"
          alt="Twitter"
        />
      </div>
    </div>
  );
};

SocialConnection.propTypes = {
  className: PropTypes.string,
};

export default SocialConnection;